export const preferences = {
  INTRO_WAS_SHOWN: 'cmCreateNewCollection.introWasShown',
}
